import type { ReactNode } from 'react'
import { cn } from '@/shared/lib'
import { Icon, type IconName } from '@/shared/ui/icon'

interface EmptyStateProps {
  icon?: IconName
  title: string
  description?: string
  action?: ReactNode
  className?: string
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-card bg-card px-6 py-14 text-center',
        className,
      )}
    >
      {icon && (
        <span className="flex size-12 items-center justify-center rounded-control bg-raise text-muted">
          <Icon name={icon} size={22} />
        </span>
      )}
      <div>
        <p className="text-body-md font-medium">{title}</p>
        {description && <p className="mt-1 text-body-sm text-muted">{description}</p>}
      </div>
      {action}
    </div>
  )
}
